export default __webpack_public_path__ + "9d511fc5e72ea3e8462457c088a4ced6.svg";